import { Category } from '@repo/types/src/glow-up';
import { CategoryCard } from './CategoryCard';

type ListProps = {
  categories: Category[];
  refetch: () => void;
};

export const CategoryList = ({ categories, refetch }: ListProps) => {
  return (
    <div className="flex flex-col gap-4 h-full overflow-auto pb-12">
      <div className="flex flex-wrap gap-4">
        {categories.map((category) => (
          <CategoryCard
            key={category.id}
            category={category}
            refetch={refetch}
          />
        ))}
      </div>
    </div>
  );
};
